import { api } from './api';
import { getTenant } from '../helpers';

export function getUserPathwaysAPI(username: string, callback) {
  const data ={
    username : username,
    platform_key : getTenant()
  }
  api.ibledxpathway.getUserPathways(data, function (data) {
    callback(data);
  });
}
